import { SCHEMES_RESPONSE, PlanTypes, IsAllow } from '../../../../redux-store/types/portfolio';
export const STPPaths = {
    STP: '/stp',
    to: '/stp/to',
    STPChangeRequest: '/stp/change',
    otp: '/stp/verify-otp',
    success: '/stp/success',
};

export type STPFlowType = {
    stpFromScheme: SCHEMES_RESPONSE;
    data?: SCHEMES_RESPONSE[];
    stpToScheme: SCHEMES_RESPONSE & { plan: PlanTypes; brokerCode?: string };
};

export type InstallmentKeyType = {
    installment: number;
    maxAmount: number;
    minAmount: number;
};

export type InstallmentFieldsType = {
    stpType?: string;
    multiples: number;
    installmentKey: InstallmentKeyType;
    perpetual: boolean;
    frequency: string;
    installmentDay: string;
    installmentError: boolean;
    numInstallments: number;
    fromDate: Date;
    toDate: Date;
    amount: string;
};

export type STPAPIDataType = {
    source: string;
    // otpEmail: string;
    // otpMobile: string;
    // otpSentTo: string;
    amc: string;
    schemeOptions: [
        {
            folio: string;
            trxnType: 'STP' | 'SWP';
            trxnDate: string;
            trxnTime: string;
            fromIsin: string;
            toIsin: string;
            reInvest: string;
            amount: string;
            variableType: string;
            startDate: string;
            endDate: string;
            frequency: string;
            stpSwpDay: string;
            distId: string;
            subDist: string;
            subBrokerARN: string;
            euin: string;
            euinDeclarationFlag: string;
            riaCode: string;
        },
    ];
};

export type STPAPIRequestType = {
    data: [STPAPIDataType];
};

export type STPAPIResponseType = {
    success: [
        {
            code: string;
            amc: string;
            amcName: string;
            folio: string;
            itemNo: string;
            schemeName: string;
            transactionType: string;
            amount: number;
            units: string;
            nav: string;
            navDate: string;
            paymentType: string;
            switchIn: {
                schemeName: string;
                amount: string;
                units: string;
                nav: string;
                navDate: string;
            };
            payment: {
                payoutBank: string;
                payoutAccount: string;
                payoutDate: string;
            };
            message: string;
            techMessage: string;
            entryDateTime: string;
            transactionStatus: string;
            sip: {
                startDate: string;
                endDate: string;
                frequency: string;
                noOfInstallments: string;
            };
            stpSwp: {
                sourceSchemeName: string;
                destSchemeName: string;
                destSchemeIdcwOpt: string;
                variableType: string;
                startDate: string;
                endDate: string;
                frequency: string;
                stpSwpDaystring: string;
            };
        },
    ];
};

export type UpperValidationOptions = {
    planType: PlanTypes;
};
